<template>
  <div class="wrapper_gray">
    <div class="header">
      <button class="btn_back" @click="logOut">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="setting_title">{{ restaurant.name }} - {{ restaurant.idx }}</h1>
      <!-- <button class="next_btn" @click="done">완료</button> -->
    </div>
    <div class="main_wrap">
      <div class="main_left">
        <!-- <h2>매장 번호</h2>
        <div class="store">
        {{ restaurant.name }} - {{ restaurant.idx }}-->
        <!-- <input v-model="restaurantIdx" type="number" class="idx" placeholder="매장번호를 입력해 주세요." /> -->
        <!-- </div> -->

        <h2>개인정보 입력</h2>
        <InfoBtn :list="privacyOptions" @changeBtn="privacyOptionChange"></InfoBtn>

        <h2>인원 명칭</h2>
        <InfoBtn :list="peopleOptions" @changeBtn="peopleOptionChange"></InfoBtn>

        <h2>메뉴 선택</h2>
        <InfoBtn :list="menuOptions" @changeBtn="menuOptionChange"></InfoBtn>
      </div>
      <div class="main_right">
        <h2>대기가능 최대 인원</h2>
        <NumCheck :num="maxPeople" :unit="'명'" @changeCount="changeMaxPeople"></NumCheck>

        <h2>번호표</h2>
        <InfoBtn :list="numTicketOptions" @changeBtn="numTicketOptionChange"></InfoBtn>

        <h2>화면 테마 설정</h2>
        <InfoBtn :list="themeOptions" @changeBtn="themeOptionChange"></InfoBtn>
      </div>
    </div>
    <div class="btn_wrap_setting">
      <button class="btn_logout" @click="logOut">로그아웃</button>
      <button class="btn_complete" @click="done">완료</button>
    </div>
  </div>
</template>

<script>
// import { getWaitingList, sendRestaurantInputOptions } from '@/api/waiting'
import NumCheck from '@/components/NumCheck'
import InfoBtn from '@/components/InfoBtn.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SettingView',
  components: {
    NumCheck,
    InfoBtn
  },
  data () {
    return {
      // 입력기본값
      // restaurantIdx: null, // 매장 id
      phoneRequired: true, // 전호번호 입력 여부
      nameRequired: true, // 이름 입력 여부
      menuRequired: false, // 메뉴선택 필수 여부
      showMenu: false, // 메뉴선택 여부
      isChildOption: false, // 성인 유아 구분 여부
      isNumTicket: false, // 번호표 사용 여부
      theme: 'basic', // 기본테마 설정
      maxPeople: 0, // 테이블당 대기가능한 인원 수
      privacyOptions: [
        {
          name: '이름+번호',
          useName: true,
          usePhone: true,
          active: false
        },
        {
          name: '전화번호만',
          useName: false,
          usePhone: true,
          active: false
        },
        {
          name: '없음',
          useName: false,
          usePhone: false,
          active: false
        }
      ],
      menuOptions: [
        {
          name: '필수 선택',
          showMenu: true,
          requiredMenu: true,
          active: false
        },
        {
          name: '취사선택',
          showMenu: true,
          requiredMenu: false,
          active: false
        },
        {
          name: '선택안함',
          showMenu: false,
          requiredMenu: false,
          active: false
        }
      ],
      peopleOptions: [
        {
          name: '인원',
          isChildOption: false,
          active: false
        },
        {
          name: '성인 + 유아',
          isChildOption: true,
          active: false
        }
      ],
      numTicketOptions: [
        {
          name: '사용',
          isNumTicket: true,
          active: false,
          disabled: false
        },
        {
          name: '사용 안함',
          isNumTicket: false,
          active: false,
          disabled: false
        }
      ],
      themeOptions: [
        {
          name: '일반 모드',
          theme: 'basic',
          active: false
        },
        {
          name: '다크 모드',
          theme: 'dark',
          active: false
        }
      ]
    }
  },
  computed: {
    ...mapState(['restaurant'])
  },
  async mounted () {
    // 기존 입력값이 있을때 기본값을 기존값으로 변경
    if (localStorage.getItem('restaurantIdx')) {
      this.phoneRequired = localStorage.getItem('phoneRequired') === 'true'
      this.nameRequired = localStorage.getItem('nameRequired') === 'true'
      this.showMenu = localStorage.getItem('showMenu') === 'true'
      this.menuRequired = localStorage.getItem('menuRequired') === 'true'
      this.isChildOption = localStorage.getItem('isChildOption') === 'true'
      this.isNumTicket = localStorage.getItem('isNumTicket') === 'true'
      this.theme = localStorage.getItem('theme')
      this.maxPeople = Number(localStorage.getItem('maxPeople'))
    }

    // 기본값을 가지고 버튼 선택상태 변경
    // 개인정보 입력
    if (this.phoneRequired && this.nameRequired) {
      this.privacyOptions[0].active = true
    } else if (this.phoneRequired && !this.nameRequired) {
      this.privacyOptions[1].active = true
    } else if (!this.phoneRequired && !this.nameRequired) {
      this.privacyOptions[2].active = true
      this.numTicketOptions[1].disabled = true
    }
    // 인원 명칭
    if (this.isChildOption) {
      this.peopleOptions[1].active = true
    } else {
      this.peopleOptions[0].active = true
    }
    // 메뉴 선택
    if (this.showMenu && this.menuRequired) {
      this.menuOptions[0].active = true
    } else if (this.showMenu && !this.menuRequired) {
      this.menuOptions[1].active = true
    } else if (!this.showMenu && !this.menuRequired) {
      this.menuOptions[2].active = true
    }
    // 번호표
    if (this.isNumTicket) {
      this.numTicketOptions[0].active = true
    } else {
      this.numTicketOptions[1].active = true
    }
    // 화면 테마 설정
    if (this.theme === 'basic') {
      this.themeOptions[0].active = true
    } else {
      this.themeOptions[1].active = true
    }
  },
  methods: {
    ...mapActions(['setRestaurant', 'setRestaurantOptions']),
    async done () {
      try {
        // await getWaitingList(this.restaurant.idx)
        localStorage.setItem('restaurantIdx', this.restaurant.idx)
        localStorage.setItem('phoneRequired', this.phoneRequired)
        localStorage.setItem('nameRequired', this.nameRequired)
        localStorage.setItem('showMenu', this.showMenu)
        localStorage.setItem('menuRequired', this.menuRequired)
        localStorage.setItem('isChildOption', this.isChildOption)
        localStorage.setItem('isNumTicket', this.isNumTicket)
        localStorage.setItem('theme', this.theme)
        localStorage.setItem('maxPeople', this.maxPeople)
        this.$i18n.locale = 'ko'

        // 매장 입력 옵션 서버통신
        let inputOptions = {
          phoneRequired: Boolean(this.phoneRequired),
          nameRequired: Boolean(this.nameRequired),
          showMenu: Boolean(this.showMenu),
          menuRequired: Boolean(this.menuRequired),
          isChildOption: Boolean(this.isChildOption),
          isNumTicket: Boolean(this.isNumTicket),
          theme: this.theme,
          maxPeople: this.maxPeople,
          isWTwo: 'true'
        }
        // sendRestaurantInputOptions(this.restaurant.idx, inputOptions)
        this.setRestaurantOptions(inputOptions).then(this.$router.push(`/`))
      } catch (e) {
        alert('정상적인 매장IDX가 아닙니다. 다시 확인해주세요')
      }
    },

    privacyOptionChange (privacy) {
      this.phoneRequired = privacy.usePhone
      this.nameRequired = privacy.useName
      if (!this.phoneRequired && !this.nameRequired) {
        this.numTicketOptions[1].disabled = true
        this.numTicketOptions[1].active = false
        this.numTicketOptions[0].active = true
        this.isNumTicket = true
      } else {
        this.numTicketOptions[1].disabled = false
        this.numTicketOptions[1].active = true
        this.numTicketOptions[0].active = false
        this.isNumTicket = false
      }
      this.changeActive(this.privacyOptions, privacy)
    },
    menuOptionChange (menuOption) {
      this.menuRequired = menuOption.requiredMenu
      this.showMenu = menuOption.showMenu
      this.changeActive(this.menuOptions, menuOption)
    },
    peopleOptionChange (peopleOption) {
      this.isChildOption = peopleOption.isChildOption
      this.changeActive(this.peopleOptions, peopleOption)
    },
    numTicketOptionChange (numTicketOption) {
      if (!numTicketOption.disabled) {
        this.isNumTicket = numTicketOption.isNumTicket
        this.changeActive(this.numTicketOptions, numTicketOption)
      }
    },
    themeOptionChange (themeOption) {
      this.changeActive(this.themeOptions, themeOption)
      this.theme = themeOption.theme
      const body = document.body
      if (body.classList.contains('basic')) {
        body.classList.remove('basic')
        body.classList.add(this.theme)
      } else if (body.classList.contains('dark')) {
        body.classList.remove('dark')
        body.classList.add(this.theme)
      } else {
        body.classList.add(this.theme)
      }
    },
    changeActive (list, param) {
      list.forEach(element => {
        element.active = false
        if (element.name === param.name) {
          element.active = true
        }
      })
    },
    changeMaxPeople (type) {
      if (type === 'decrease') {
        this.maxPeople = this.maxPeople - 1 >= 0 ? this.maxPeople - 1 : 0
      } else {
        this.maxPeople = Number(this.maxPeople) + 1
      }
    },
    logOut () {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/base.scss";

.header {
  position: relative;
  width: 100%;
  height: 70px;
  background: $indigo_dark;
  h1.setting_title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 100%;
    height: 70px;
    font-size: 36px;
    font-weight: bold;
    color: $white;
  }
  .next_btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 120px;
    height: 70px;
    border: 0;
    background: $positive;
    color: $white;
    font-size: 24px;
    font-weight: bold;
  }
}

.main_wrap {
  display: flex;
  justify-content: space-between;
  padding: 60px 90px 0;
  h2 {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .main_left {
    width: 510px;
    .store {
      height: 57px;
      line-height: 57px;
      font-size: 30px;
    }
    div {
      margin-bottom: 20px;
      .idx {
        width: 100%;
        height: 57px;
        font-size: 30px;
        padding: 0 15px;
        box-sizing: border-box;
        border: 0;
        border-radius: 3px;
        &::placeholder {
          color: rgba(48, 48, 48, 0.5);
        }
      }
    }
  }
  .main_right {
    width: 510px;
    h2 {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    div {
      margin-bottom: 20px;
    }
    .menu_sel {
      display: flex;
      justify-content: space-between;
      height: 57px;
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 165px;
        height: 100%;
        background: #fff;
        font-size: 30px;
        color: rgba(48, 48, 48, 0.5);
        border-radius: 3px;
        &.active {
          background: $select;
          color: $white;
        }
        &.disable {
          background: $cancle_gray;
          color: $white_op;
          border: 1px solid #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}
.info_sel {
  display: flex;
  justify-content: space-between;
  height: 57px;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 165px;
    height: 100%;
    background: #fff;
    font-size: 30px;
    color: var(--font_basic);
    border-radius: 3px;
    &.active {
      background: $select;
      color: $white;
    }
    &.disabled {
      background: $cancle_gray;
      color: $white_op;
    }
    &:nth-last-child(2),
    &:nth-last-child(2) ~ li {
      width: 252px;
    }
    &:nth-last-child(3),
    &:nth-last-child(3) ~ li {
      width: 165px;
    }
    &:nth-last-child(4),
    &:nth-last-child(4) ~ li {
      width: 120px;
    }
  }
}

.num_pad {
  display: flex;
  justify-content: space-between;
  height: 57px;

  .display_num {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 382px;
    height: 57px;
    background: $white;
    color: $black;
    font-size: 30px;
    border-radius: 3px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 54px;
    height: 57px;
    background: $white;
    border: 0;
    border-radius: 3px;
  }
}

.btn_wrap_setting {
  display: flex;
  padding: 30px 90px 0;
  justify-content: center;
  .btn_logout {
    width: 240px;
    height: 102px;
    line-height: 102px;
    background: $noshow_gray;
    color: $white;
    font-size: 36px;
    font-weight: bold;
    border-radius: 3px;
    margin-right: 18px;
  }
  .btn_complete {
    width: 862px;
    height: 102px;
    line-height: 102px;
    background: $positive;
    font-size: 36px;
    font-weight: bold;
    color: $white;
    border-radius: 3px;
  }
}
</style>
